import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { ecgVoltage } from './ecgModel.js';
import { RESTING_HEART_RATE, heartRate } from './pulseModel.js';

const COLOR = [46, 255, 83];
const sample = (seconds) => 110 - 75 * ecgVoltage(seconds);

const ECGSketch = () => (
  <PulseMonitor
    label="ECG II"
    className="ecg"
    color={COLOR}
    sample={sample}
    // Four samples per CSS pixel preserve a narrow QRS throughout the sweep.
    sampleStep={0.25}
    readout={heartRate}
    limits={[50, 120]}
    initialValue={RESTING_HEART_RATE}
    valueId="hr-bpm-value"
    unit="HR /min"
  />
);

export default ECGSketch;
